export default {"betButtonWrapper":"_10oRh","betButton":"OEI7N","shouldHideLabelOnMobile":"QvDpX","shouldHideLabelOnDesktop":"kCHuu"};